module.exports = __webpack_public_path__ + "img/155.afc3f9d2.png";